import { AppText, AppIcon } from "@toothfairy/shared-ui";
import AppDot from "@toothfairy/shared-ui/AppDot";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import React, { useMemo } from "react";
import { View } from "react-native";
import AppAssets from "@toothfairy/shared-ui/AppAssets";
import { Popable } from "react-native-popable";

const SavingNotification = ({
  label,
  isProgress,
  color,
  dotValue,
  isDotVisible = false,
  icon,
  showEditBtn,
  isEditEnabled,
  setIsEditEnabled,
  setLastCancellation,
  isParser = true,
  setIsSaveRequested,
  embeddingProgress,
  embeddingStatus,
  children,
  setShowSourcesModal,
  fetchEmbeddingsByDocument,
}) => {
  const { currentTheme } = AppTheme.useTheme();
  const mapEmbeddingStatusToText = (embeddingStatus) => {
    switch (embeddingStatus) {
      case "draft":
        return "Learning not started";
      case "pending":
        return "Learning pending";
      case "failed":
        return "Learning failed";
      case "ready":
        return "Learning completed";
      case "not_ready":
        return "Learning in progress";
      default:
        return "Learning not started";
    }
  };
  function formatPercentage(num, decimalPlaces = 0) {
    return num.toFixed(decimalPlaces) + "%";
  }

  return (
    <View
      style={{
        flexDirection: "row",
        alignItems: "center",
        alignSelf: "flex-start",
        marginTop: 10,
        marginRight: 5,
        minWidth: isParser ? 120 : 20,
        // justifyContent: "flex-end",
      }}
    >
      {showEditBtn && (
        <>
          {children}
          {isEditEnabled && (
            <AppText
              isClickable
              onPress={() => {
                setLastCancellation(Date.now());
              }}
              wrapperStyle={{
                marginRight: 5,
                marginTop: 2,
              }}
              style={{
                fontWeight: "bold",
              }}
              isHoverable={false}
              color={currentTheme?.theme?.orange}
              size={20}
            >
              Cancel
            </AppText>
          )}
          <Popable
            numberOfLines={2}
            backgroundColor={currentTheme?.theme?.tooltipBackgroundColor}
            style={[
              {
                top: 30,
                zIndex: 20,
                maxWidth: 300,
              },
            ]}
            content={isEditEnabled ? "Submit Header" : "Update Header"}
            action="hover"
            position="left"
          >
            <AppText
              isClickable
              onPress={() => {
                setIsEditEnabled(!isEditEnabled);
                if (!isEditEnabled && setIsSaveRequested)
                  setIsSaveRequested(Date.now()?.toString());
              }}
              leftIcon={
                isEditEnabled ? AppAssets?.icons?.check : AppAssets?.icons?.edit
              }
              isHoverable={false}
              style={{
                marginLeft: 10,
              }}
              wrapperStyle={{
                paddingLeft: 5,
                marginRight: -10,
              }}
              fontWeight="bold"
              color={
                isEditEnabled
                  ? currentTheme?.theme?.primary
                  : currentTheme?.theme?.primary
              }
              iconSize={16}
            >
              {isEditEnabled ? "" : ""}
            </AppText>
          </Popable>

          <AppIcon
            icon={AppAssets?.icons?.separator}
            color={currentTheme?.theme?.mediumGrey}
            isActive={false}
            size={18}
            wrapperStyle={{
              marginHorizontal: 10,
            }}
          />
        </>
      )}
      {label != "No document selected" && (
        <>
          {isDotVisible && (
            <AppDot
              forcedValue={dotValue}
              dotSize={8}
              dotStyle={{
                marginRight: -5,
                backgroundColor: currentTheme?.theme[color],
              }}
            />
          )}
          <Popable
            numberOfLines={2}
            backgroundColor={currentTheme?.theme?.tooltipBackgroundColor}
            style={[
              {
                top: 30,
                zIndex: 20,
                maxWidth: 300,
              },
            ]}
            content={label}
            action="hover"
            position="left"
          >
            <AppText
              style={{
                marginLeft: 5,
                fontSize: currentTheme?.theme?.medium_font_size,
              }}
              fontWeight={"bold"}
              leftIcon={!isDotVisible && icon}
              wrapperStyle={{
                marginBottom: !showEditBtn && 8,
              }}
              iconSize={20}
              color={currentTheme?.theme[color]}
            ></AppText>
          </Popable>
          {showEditBtn && (
            <>
              <AppIcon
                icon={AppAssets?.icons?.separator}
                color={currentTheme?.theme?.mediumGrey}
                isActive={false}
                size={20}
              />
              <Popable
                numberOfLines={3}
                backgroundColor={currentTheme?.theme?.tooltipBackgroundColor}
                style={[
                  {
                    top: 30,
                    zIndex: 20,
                    maxWidth: 300,
                  },
                ]}
                content={`${mapEmbeddingStatusToText(embeddingStatus)}${
                  embeddingStatus == "not_ready"
                    ? ` - ${formatPercentage(embeddingProgress)}`
                    : ""
                }`}
                action="hover"
                position="left"
              >
                <View>
                  <AppIcon
                    isClickable={embeddingStatus == "ready"}
                    isHoverable
                    onPress={() => {
                      setShowSourcesModal(true);
                      fetchEmbeddingsByDocument();
                    }}
                    color={
                      embeddingStatus == "ready"
                        ? currentTheme?.theme?.green
                        : currentTheme?.theme?.orange
                    }
                    icon={
                      embeddingStatus == "ready" ||
                      embeddingStatus == "not_ready"
                        ? AppAssets.icons.deepFileSearch
                        : AppAssets.icons.clock
                    }
                    iconSize={22}
                    style={{
                      marginLeft: 5,
                      fontWeight: "bold",
                      textDecorationColor:
                        embeddingStatus == "ready"
                          ? currentTheme?.theme?.green
                          : currentTheme?.theme?.orange,
                    }}
                  />
                  {embeddingStatus == "not_ready" && (
                    <AppText
                      wrapperStyle={{
                        position: "absolute",
                        top: 19,
                        left: 3,
                        minWidth: 23,
                        alignItems: "center",
                        display: "flex",
                        justifyContent: "center",
                      }}
                      style={{
                        fontSize: 10,
                        fontWeight: "bold",
                      }}
                      color={currentTheme?.theme?.orange}
                    >{`${formatPercentage(embeddingProgress)}`}</AppText>
                  )}
                </View>
              </Popable>
            </>
          )}
        </>
      )}
    </View>
  );
};

export default SavingNotification;
